import React from "react";
import { Field, reduxForm } from "redux-form";

import Button from "components/atoms/button/index.jsx";
import FormFieldset from "components/molecules/formFieldset/index.jsx";
import FormCol from "components/molecules/formCol/index.jsx";
import FormTextField from "components/molecules/formTextField/index.jsx";
import FormTextSelect from "components/molecules/formSelect/index.jsx";
import FormActions from "components/molecules/formActions/index.jsx";

import validate from "components/organisms/buyForm/validate.jsx";

class PersonalInformationForm extends React.Component {
  render() {
    const maritalStatusOptions = [
      null,
      "Soltero",
      "Casado",
      "Divorciado",
      "Viudo",
    ];

    return (
      <form onSubmit={this.props.handleSubmit}>
        <h3>Datos personales</h3>
        <FormFieldset>
          <FormCol first="true">
            <Field
              name="name"
              type="text"
              component={FormTextField}
              label="Nombre"
            />

            <Field
              name="dni"
              type="text"
              component={FormTextField}
              label="DNI"
            />

            <Field
              name="maritalStatusId"
              component={FormTextSelect}
              label="Estado civil"
              options={maritalStatusOptions}
            />
          </FormCol>
          <FormCol last="true">
            <Field
              name="lastname"
              type="text"
              component={FormTextField}
              label="Apellido"
            />

            <Field
              name="birthdate"
              type="text"
              component={FormTextField}
              placeholder="dia/mes/año"
              label="Fecha de nacimiento"
            />

            <Field
              name="spouseName"
              type="text"
              component={FormTextField}
              placeholder="Solo si es casado"
              label="Apellido del cónyuge"
            />
          </FormCol>
        </FormFieldset>

        <FormActions>
          <Button buttonText="Continuar" type="submit" />
        </FormActions>
      </form>
    );
  }
}

export default reduxForm({
  form: "buy",
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(PersonalInformationForm);
